module.exports = fox._r("images/slides/urban/slide_1_5.jpg", __webpack_public_path__ + "images/slides/urban/slide_1_5.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/urban/slide_1_5.jpg
// module id = 52
// module chunks = 2